import axios from 'axios';

const http = axios.create();

function generateRoute(routeName, params = {}) {
    return Routing.generate(routeName, params);
}

async function handleRequest(method, routeName, params = {}, payload = null) {
    try {
        const url = generateRoute(routeName, params);
        const response = await http[method](url, payload);
        return response;
    } catch (error) {
        console.error(`Failed to ${routeName}:`, error);
        throw error;
    }
}

export const NotesPageApi = {
    async getPageInfo() {
        const response = await handleRequest('get', 'api_notes_page_info');
        return response.data.info;
    },
    async saveBookmark(data) {
        return await handleRequest('post', 'save_bookmark', {}, data);
    },

    async saveAnnotation(data) {
        return await handleRequest('post', 'create_note', {}, data);
    },

    async getBookmark(id) {
        return await handleRequest('get', 'get_bookmark', { id: id });
    },

    async getAnnotation(id) {
        return await handleRequest('get', 'get_note', { id : id});
    },

    async deleteBookmark(id) {
        return await handleRequest('get', 'remove_bookmark', { id : id });
    },

    async deleteAnnotation(id) {
        return await handleRequest('get', 'remove_note', { noteId: id });
    },
    async getGroupedByTitlesInfo(queryParams) {
        const response = await handleRequest('get', 'api_notes_group_by_title_info', queryParams);
        return response.data;
    }
};
